import styled from 'styled-components'

export const Wrapper = styled.div`
    width: 100%;
    height: calc(100vh - 64px);
    background-color: #ebebeb;

    display: flex;
    flex-direction: column;
    justify-content: stretch;
`

export const TimelineArea = styled.div`
    flex: 1 1;
`

export const OptionsBarArea = styled.div`
    flex: 0 1;
`
